import { motion } from "framer-motion";

const AnimatedCrossIcon = () => {
  return (
    <motion.svg
      width="100"
      height="100"
      viewBox="0 0 24 24"
      fill="none"
      stroke="red"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="flex items-center justify-center"
    >
      {/* Círculo (opcional) */}
      <motion.circle
        cx="12"
        cy="12"
        r="10"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{
          duration: 0.5,
          ease: "easeInOut",
        }}
      />

      {/* Línea 1 de la X */}
      <motion.path
        d="M8 8L16 16"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{
          duration: 0.3,
          ease: "easeInOut",
          delay: 0.6,
        }}
      />

      {/* Línea 2 de la X */}
      <motion.path
        d="M16 8L8 16"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{
          duration: 0.3,
          ease: "easeInOut",
          delay: 0.9,
        }}
      />
    </motion.svg>
  );
};

export default AnimatedCrossIcon;
